import React, { Component } from 'react';
import axios from '../../../axios-ns';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

class Training extends Component {
    state = {
        materialCode: null,
        message: ''
    }

    componentDidMount() {
        this.setState({ transactionCode: this.props.transactionCode, materialCode: this.props.materialCode, workoutCode: this.props.workoutCode });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const obj = {materialCode: this.state.materialCode, message: this.state.message, transactionCode: this.state.transactionCode, workoutCode: this.state.workoutCode};

        axios.post('/protected/audio/createStudentQuestion', obj, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then(response => {
            this.setState({...this.state, message: '' })
            this.props.onMessageSent();
        })
        .catch(err => {
            alert("Wiadomość nie mogła zostać wysłana");
        })
    }

    handleChange = (event) => {
        this.setState({...this.state, message: event.target.value });
    }

    render() {
        return (
            <div style={{paddingLeft: '5px', paddingRight: '5px'}}>
                <form onSubmit={(event) => this.handleSubmit(event)}>
                    <TextField
                        id="outlined-multiline-flexible"
                        label="Twoja wiadomość"
                        multiline
                        rowsMax="4"
                        value={this.state.message}
                        onChange={(event) => this.handleChange(event, 'message')}
                        margin="normal"
                        helperText="Opisz proszę możliwie precyzyjnie swoje pytanie."
                    />

                    <Button variant="outlined" type="submit" color="primary">Wyślij</Button>
                </form>
            </div>
        );
    };
}

export default Training;